import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FaTrash as TrashIcon, FaDownload as DownloadIcon } from 'react-icons/fa';
import classnames from 'classnames';
import convertBase64UrlToBlobObjectUrl from '../utils/convertBase64UrlToBlobObjectUrl';
import { toImageDataUrl } from '../utils/imageDataUrl';

const noop = () => ({});

class SingleAttachment extends PureComponent {
  static propTypes = {
    file: PropTypes.shape({
      fileName: PropTypes.string.isRequired,
      fileType: PropTypes.string.isRequired,
      fileImage: PropTypes.string,
    }).isRequired,
    removeFile: PropTypes.func,
    showImage: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    showImage: false,
    disabled: false,
  };

  state = {
    blobObjectUrl: null,
  };

  componentDidMount() {
    this.getBlobObjectUrl();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.file !== this.props.file) {
      this.getBlobObjectUrl();
    }
  }

  getBlobObjectUrl = () => {
    const fileImage = this.props.file.fileImage;

    if (fileImage) {
      const base64FileImage = fileImage.startsWith('data:')
        ? fileImage
        : `data:application/octet-stream;base64,${fileImage}`;

      // converting base64 to blob to allow chrome to download files larger than 2MB
      convertBase64UrlToBlobObjectUrl(base64FileImage).then(blobObjectUrl => this.setState({ blobObjectUrl }));
    } else {
      const { removeFile = noop } = this.props;
      removeFile(this.props.file);
    }
  };

  removeAttachment = event => {
    event.preventDefault();

    const { removeFile = noop, disabled } = this.props;

    if (disabled) {
      return;
    }

    removeFile(this.props.file);
  };

  render() {
    const { blobObjectUrl } = this.state;

    const { file, removeFile, showImage } = this.props;
    const { fileImage, fileName } = file;

    return (
      <div className={classnames('single-attachment', { 'single-attachment-with-image': showImage })}>
        {removeFile && <button className="btn btn-link" onClick={this.removeAttachment}><TrashIcon /></button>}
        {fileImage && <a className="btn btn-link" download={fileName} href={blobObjectUrl}><DownloadIcon /></a>}
        {fileImage && showImage
          ? <img className="menu-item-client" src={toImageDataUrl(fileImage)} alt="attachment" />
          : <span className="filename" title={fileName}>{fileName}</span>
        }
      </div>
    );
  }
}

export default SingleAttachment;
